export const detailsDictionary = {
    "Cierre anterior": {
        es: "Cierre anterior",
        en: "Previous Close",
    },
    Apertura: {
        es: "Apertura",
        en: "Open",
    },
    Mínimo: {
        es: "Mínimo",
        en: "Low",
    },
    Máximo: {
        es: "Máximo",
        en: "High",
    },
    Volumen: {
        es: "Volumen",
        en: "Volume",
    },
    Cantidad: {
        es: "Cantidad",
        en: "Quantity",
    },
    Compra: {
        es: "Compra",
        en: "Buy",
    },
    Venta: {
        es: "Venta",
        en: "Sell",
    },
    Precio: {
        es: "Precio",
        en: "Price",
    },
    "Selecciona una opción": {
        es: "Selecciona una opción",
        en: "Select an option",
    },
    Resumen: {
        es: "Resumen",
        en: "Summary",
    },
    Comparador: {
        es: "Comparador",
        en: "Comparator",
    },
    "Datos históricos": {
        es: "Datos históricos",
        en: "Historical data",
    },
    Fecha: {
        es: "Fecha",
        en: "Date",
    },
    "Monto operado": {
        es: "Monto operado",
        en: "Amount operated",
    },
    Histórico: {
        es: "Histórico",
        en: "Historical",
    },
    Actualización: {
        es: "Actualización",
        en: "Update",
    },
    Hoy: {
        es: "Hoy",
        en: "Today",
    },
    Semana: {
        es: "Semana",
        en: "Week",
    },
    "1 mes": {
        es: "1 mes",
        en: "1 month",
    },
    "3 meses": {
        es: "3 meses",
        en: "3 months",
    },
    "6 meses": {
        es: "6 meses",
        en: "6 months",
    },
    "1 año": {
        es: "1 año",
        en: "1 year",
    },
    YTD: {
        es: "YTD",
        en: "YTD",
    },
    Todo: {
        es: "Todo",
        en: "All",
    },
};
